import React, { FC } from "react";
import { useTheme } from "@mui/material/styles";
import { IconButton, Stack } from "@mui/material";
import { ColorModeContext } from "../../../contexts/ColorModeContext";
import IconComponent from "../../../components/ui/IconComponent";
import { useTranslation } from "react-i18next";
import Text from "../../../_components/Text";

export const SwitchTheme: FC = () => {
  const theme = useTheme();
  const { t } = useTranslation("profile");

  const { activeMode, setLightMode, setDarkMode, setSystemMode } =
    React.useContext(ColorModeContext);

  const ActiveItem = {
    outline: "2px solid #7543ff",
    outlineOffset: "-2px",
  };

  return (
    <Stack direction={"column"} alignItems={"center"} spacing={1} sx={{ width: "100%" }}>
      <Stack
        sx={activeMode === "light" ? ActiveItem : {}}
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        spacing={1}
        onClick={setLightMode}
        padding="7px 16px"
        borderRadius="12px"
        width="100%"
        bgcolor={theme.myTheme.colors.gray400}
      >
        <Text variant="regular-semi">{t("light")}</Text>
        <IconButton color="inherit">
          <IconComponent iconName={"Sun"} size={18} hasStroke hasFill={true} />
        </IconButton>
      </Stack>
      <Stack
        sx={activeMode === "system" ? ActiveItem : {}}
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        spacing={1}
        onClick={setSystemMode}
        padding="7px 16px"
        borderRadius="12px"
        width="100%"
        bgcolor={theme.myTheme.colors.gray400}
      >
        <Text variant="regular-semi">{t("system")}</Text>
        <IconButton color="inherit">
          <IconComponent iconName={"Half"} size={18} hasStroke />
        </IconButton>
      </Stack>
      <Stack
        sx={activeMode === "dark" ? ActiveItem : {}}
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        spacing={1}
        onClick={setDarkMode}
        padding="7px 16px"
        borderRadius="12px"
        width="100%"
        bgcolor={theme.myTheme.colors.gray400}
      >
        <Text variant="regular-semi">{t("dark")}</Text>
        <IconButton color="inherit">
          <IconComponent iconName={"MoonStar"} size={18} hasStroke hasFill />
        </IconButton>
      </Stack>
    </Stack>
  );
};
